import * as msg from '../../../../node_modules/console-tags.js/src/console-tags.js'

const Watermark = () => {
  const bgImg = 'https://samline.github.io/shido/dist/img/logos/logo-shido.svg'

  console.log(
    '%c ',
    'background: url(' + bgImg + ') no-repeat center/150px; color: white; padding: 30px 75px'
  )

  msg.custom('samline', 'Made with love', '#FD7272')
}

export default Watermark()
